import React, { useEffect, useContext, useState }  from 'react'
import { View, StyleSheet, FlatList, TouchableOpacity, SafeAreaView, Platform } from 'react-native'
import StyledTextInput from './StyledTextInput'
import { Icon, Text, Button, Modal, Card, useTheme } from '@ui-kitten/components'
import { UserContext } from '../global/UserProvider'
import HeaderIconButton from './HeaderIconButton'
import { useAtom, useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'
import * as Sentry from '@sentry/react-native'
import { resolveRealIndex } from './universalListIndex'

const getInitialData = (initialData, initialDataPath) => {
  let d = initialData
  initialDataPath.forEach((element) => {
    d = d[element]
  })
  return d
}

export default function UniversalListScreen({ navigation, route }) {
  const { t } = useTranslation()
  const theme = useTheme()
  const { initialDataPath, atom, searchField, detailScreen, title } = route.params
  const atomValue = useAtomValue(atom)
  const [initialData, setInitialData] = useState(initialDataPath ? getInitialData(atomValue, initialDataPath) : Object.values(atomValue))
  const [data, setData] = useState(initialData)
  const [query, setQuery] = useState('')

  useEffect(() => {
    // to update list after modifications
    let newInitialData = initialDataPath ? getInitialData(atomValue, initialDataPath) : Object.values(atomValue)
    setInitialData(newInitialData)
    setData(newInitialData)
    navigation.setOptions({
      headerRight: () => (
        <HeaderIconButton
          onPress={() => {
            navigation.navigate(detailScreen, {detail: null, detailIndex: (newInitialData?.length || 0), allData: (newInitialData || [])})
          }}
          iconName='plus-outline'
        />
      ),
      title: title
    })
  }, [atomValue, title])

  const handleSearch = text => {
    setQuery(text)
    const filteredValue = initialData.filter(function(doc) {
      return doc[searchField].toLowerCase().indexOf(text.toLowerCase()) > -1;
    })
    // fuse - slow and categorized
    // const fuse = new Fuse(value.data, {
    //   keys: ['name']
    // })
    // const filteredValue = fuse.search(text).map(i => i.item)
    setData(filteredValue)
  }

  const renderSearchHeader = () => (
    <View style={styles.listHeader}>
      <StyledTextInput autoCapitalize="none"
        autoCorrect={false}
        clearButtonMode="always"
        value={query}
        onChangeText={queryText => handleSearch(queryText)}
        placeholder={t('search')}
        returnKeyType='done'
        style={styles.input}
        selectTextOnFocus={true}
      />
    </View>
  )


  const renderItem = ({item, index}) => {
    return (
      <TouchableOpacity
        style={[styles.item, { backgroundColor: theme['background-basic-color-1'] }]}
        onPress={() => {
          // ATL-819: `index` is a position in the FILTERED array; the writer needs the position in
          // `initialData`, the array it rewrites wholesale. See `./universalListIndex`.
          const realIndex = resolveRealIndex(item, initialData)
          if (realIndex === -1) {
            // The tapped row cannot be addressed in the array a save would persist. Opening the
            // detail screen anyway would let the save overwrite an arbitrary element, so refuse.
            // No item fields are attached — this list carries wallet names, user names and roles.
            Sentry.captureMessage('UniversalList: tapped item is not addressable in initialData (ATL-819)', {
              level: 'error',
              extra: {
                detailScreen,
                searchField,
                listLength: initialData?.length ?? null,
                filteredLength: data?.length ?? null,
                filteredIndex: index,
                itemHasId: item?.id !== undefined && item?.id !== null && item?.id !== '',
              },
            })
            return
          }
          navigation.navigate(detailScreen, {detail: item, detailIndex: realIndex, allData: initialData})
          setQuery('')
        }}
        key={item.id}
        testID={`list-item-${index}`}
        dataSet={{ testid: `list-item-${index}` }}
      >
        <Text
          style={styles.itemTitle}
          category='s2'>
          {item[searchField]}
        </Text>
      </TouchableOpacity>
    )
  }

  const renderFooter = () => (
    <View style={{height:50}}></View>
  )

  return (
    <FlatList
      ListHeaderComponent={renderSearchHeader()}
      data={data}
      keyExtractor={(item, index) => item + index}
      renderItem={renderItem}
      style={styles.list}
      keyboardDismissMode='on-drag'
      keyboardShouldPersistTaps='handled'
      ListFooterComponent={renderFooter()}
    />
  )
}

const styles = StyleSheet.create({
  list: {
    paddingHorizontal: 20,
  },
  input: {
    marginTop: 20,
  },
  item: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 2,
    paddingHorizontal: 14,
    backgroundColor: '#FFFFFF',
    borderRadius: 5,
    height: 56,
  },
  listHeader: {
    // height: 200,
    justifyContent: 'center',
    marginBottom: 20,
    // position: Platform.OS === 'web' ? 'fixed' : undefined,
    // top: Platform.OS === 'web' ?  0 : undefined,
    // zIndex: Platform.OS === 'web' ? 4 : undefined,
    // backgroundColor: Platform.OS === 'web' ? 'white' : undefined,
    // paddingHorizontal: Platform.OS === 'web' ? 20 : undefined,
  },
})
